module.exports = __webpack_public_path__ + "img/utilityhydrant_parked.75289d8b.svg";